/**
 * Mock data and types for the Settings page
 * Types for club organization (opening hours, age groups, etc.)
 * Manager and ClubInfo types have been moved to their respective components
 */

// ============ Types ============

export interface AgeGroup {
  id: string;
  name: string;
  minAge: number;
  maxAge: number;
}

export interface PeriodHours {
  active: boolean;
  start: string;
  end: string;
  maxChildren: number;
}

export interface OpeningHours {
  matin: PeriodHours;
  midi: PeriodHours;
  apres: PeriodHours;
}

// ============ Mock Data ============

export const mockAgeGroups: AgeGroup[] = [
  { id: "1", name: "Les Petits", minAge: 2, maxAge: 7 },
  { id: "2", name: "Les Grands", minAge: 8, maxAge: 12 },
];

export const mockOpeningDates = {
  startDate: "07/07/2025",
  endDate: "23/08/2025",
};

export const mockOpeningDays = ["lundi", "mardi", "mercredi", "jeudi", "vendredi"];

const defaultPeriod: PeriodHours = {
  active: false,
  start: "-",
  end: "-",
  maxChildren: 0,
};

const activeMorning: PeriodHours = {
  active: true,
  start: "09h00",
  end: "12h00",
  maxChildren: 20,
};

const activeAfternoon: PeriodHours = {
  active: true,
  start: "14h00",
  end: "18h00",
  maxChildren: 20,
};

export const mockOpeningHours: Record<string, OpeningHours> = {
  lundi: { matin: activeMorning, midi: defaultPeriod, apres: activeAfternoon },
  mardi: { matin: activeMorning, midi: defaultPeriod, apres: activeAfternoon },
  mercredi: { matin: activeMorning, midi: defaultPeriod, apres: activeAfternoon },
  jeudi: { matin: activeMorning, midi: defaultPeriod, apres: activeAfternoon },
  vendredi: { matin: activeMorning, midi: defaultPeriod, apres: activeAfternoon },
  samedi: { matin: defaultPeriod, midi: defaultPeriod, apres: defaultPeriod },
  dimanche: { matin: defaultPeriod, midi: defaultPeriod, apres: defaultPeriod },
};

export const mockClosures: string[] = [
  "2025-02-05",
  "2025-02-06",
  "2025-02-07",
  "2025-02-10",
];
